import { createSelector } from '@ngrx/store';
import { featureKey, UserState } from '../reducers/user.reducer';

export const selectUser = createSelector(
  (state: any) => state[featureKey],
  (userState: UserState) => userState?.currentUser ?? undefined,
);

export const selectLoadingUser = createSelector(
  (state: any) => state[featureKey],
  (userState: UserState) => userState.loading,
);

export const selectProfileComplete = createSelector(
  (state: any) => state[featureKey],
  (userState: UserState) => {
    if (!userState.currentUser) {
      return undefined;
    }
      return (
        !!userState.currentUser?.first_name && !!userState.currentUser?.last_name
      );

  },
);
